import { initModules, loadScript } from "../../../../magnolia-component-library/assets/js/utils";
import LazyLoader from "../../../../magnolia-component-library/assets/js/utils/lazyLoading/lazyLoader";
import LazyElements from "../../../../magnolia-component-library/assets/js/utils/lazyLoading/lazyElements";
import SmoothScroll from "../../../../magnolia-component-library/assets/js/utils/smooth-scroll";
import ScrollAnimations from "../../../../magnolia-component-library/assets/js/utils/scrollAnimations";

import EmbeddedForm from "../../../../magnolia-component-library/assets/js/modules/marketo/embeddedForms/index";
import ScrollTop from "../../../../magnolia-component-library/assets/js/modules/scroll-top";
import SyntaxHighlighter from "../../../../magnolia-component-library/assets/js/modules/syntaxHighlighter/index";
import Expandable from "../../../../magnolia-component-library/assets/js/modules/expandable";
import Slider from "../../../../magnolia-component-library/assets/js/modules/slider";
import LottiePlayer from "../../../../magnolia-component-library/assets/js/modules/lottie-player";
import Modal from "../../../../magnolia-component-library/assets/js/modules/modal";
import Accordion from "../../../../magnolia-component-library/assets/js/modules/accordion";
import Dropdown from "../../../../magnolia-component-library/assets/js/modules/dropdown";
import DamVideo from "../../../../magnolia-component-library/assets/js/modules/damVideo";
import TextCopy from "../../../../magnolia-component-library/assets/js/modules/text-copy";
import Ads from "../../../../magnolia-component-library/assets/js/modules/ads";

import PostsListing from "./modules/postsListing";
import Post from "./modules/post";
import ReadLength from "./modules/readLength";

window.addEventListener("load", function() {
    ScrollAnimations();
    SmoothScroll();
    LazyLoader(".e-in", { rootMargin: "-25px", threshold: 0 }, LazyElements);

    initModules({
        Slider,
        TextCopy,
        ScrollTop,
        SyntaxHighlighter,
        Expandable,
        Modal,
        Accordion,
        Dropdown,
        DamVideo,
        PostsListing,
        Post,
        ReadLength,
        Ads,
    });

    loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light_canvas.min.js",
        document.querySelector(".js-module-lottie-player")
    )
        .then(() => initModules({ LottiePlayer }))
        .catch(() => {});

    EmbeddedForm();
});
